import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavbarInitiative } from "@hooks/useNavbarInitiative";
import { usePaginatedList } from "@hooks/usePaginatedList";
import UserItem from "../UsersGroups/components/UserItem";
import { useUsersGroupsActions } from "../UsersGroups/hooks/useUsersGroupsActions";
import { useCorporateMfaConfig } from "../UsersGroups/hooks/useCorporateMfaConfig";
import ResetTotp from "../UsersGroups/MfaManagement/ResetTotp";
import { buildUGListUrl } from "../UsersGroups/types";
import PanelList from "./PanelList";

const PAGE_SIZE = 5;

export default function UsersPanel() {
  const { id: corporateId = "" } = useParams();
  const { selectedInitiative } = useNavbarInitiative();
  const { totpEnabled } = useCorporateMfaConfig(corporateId);
  const [authenticationUser, setAuthenticationUser] = useState<{
    id_user: string | number;
  }>();

  const listUrl = useMemo(
    () => buildUGListUrl("users", corporateId),
    [corporateId],
  );

  const filters = useMemo(
    () => ({
      page: 1,
      pageSize: PAGE_SIZE,
      sort: "most-recent",
      fieldFilters:
        selectedInitiative && selectedInitiative !== "all"
          ? { initiative_id: selectedInitiative }
          : undefined,
    }),
    [selectedInitiative],
  );

  const { items, isLoading, mutate } = usePaginatedList(listUrl, filters);

  const { userActions, modals } = useUsersGroupsActions({
    corporateId,
    onRefresh: () => mutate && mutate(),
  });

  return (
    <>
      <PanelList isLoading={isLoading} isEmpty={items.length === 0}>
        {items.map((user: any) => (
          <UserItem
            key={`user-${user.id_user}`}
            user={user}
            corporateId={corporateId}
            totpEnabled={totpEnabled}
            selectable={false}
            {...userActions}
            onManageAuthentication={(user) => setAuthenticationUser(user)}
          />
        ))}
      </PanelList>
      {!!authenticationUser && totpEnabled && (
        <ResetTotp
          key={`${corporateId}-${authenticationUser.id_user}`}
          open
          corporateId={corporateId}
          idUser={authenticationUser.id_user}
          onClose={() => setAuthenticationUser(undefined)}
        />
      )}
      {modals}
    </>
  );
}
